<div class="container-fluid">
    <div class="row">
      <div class="col-12 mt-5 text-center">
        <h2>Oops! Something went wrong</h2>
        <p>ERROR: {{ ErrorMessage }}</p>
      </div>
    </div>
  </div>